// this file is overwritten by scripts/write-version.js on deploy
export default {
  data() {
    return {
      cuonaManagerVersion: 'develop-14a024e1',
      cuonaManagerEnvironment: 'bleeding-edge'
    };
  }
};
